<div class="pagination-main">
	<div class="pagination-component">
		<div>
			<lbca-icon
				name="ic:round-arrow-left"
				[class.active-color]="page > 1"
				[class.inactive-color]="page === 1"
				[class.active]="page > 1"
				[class.inactive]="page === 1"
				(click)="goTo($event, 'prev')"
			/>
		</div>

		<div class="pagination-pages-controller">
			<span class="pagination-current-page">{{ page }}</span>
			@if (!hideMaxPages) {
				{{ fieldsLabels['paginator-separator'] }} {{ lastPage }}
			}
		</div>

		<div>
			<lbca-icon
				name="ic:round-arrow-right"
				[class.active-color]="page < lastPage"
				[class.inactive-color]="page === lastPage"
				[class.inactive]="page === lastPage"
				[class.active]="page < lastPage"
				(click)="goTo($event, 'next')"
			/>
		</div>
	</div>
</div>
